import { createTheme } from '@mui/material/styles';

// Horwath HTL Brand Colors
export const brandColors = {
  gold: '#F5A800',
  darkGold: '#C08500',
  indigo: '#607D8B',
  blue: '#003F9F',
  white: '#FFFFFF',
  lightGray: '#F8F9FA',
  mediumGray: '#686E77',
  darkGray: '#32373C',
};

// Custom Chip Status Colors
export const chipColors = {
  warning: '#FFCC00',  // Yellow for warnings/pending
  error: '#C4161C',    // Dark red for errors/required
  info: '#97a3c2',     // Blue-gray for informational
};

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: brandColors.gold,
      light: '#FFC344',
      dark: brandColors.darkGold,
    },
    secondary: {
      main: brandColors.indigo,
      light: '#2C3E5C',
      dark: '#0A1520',
    },
    info: {
      main: chipColors.info,
      light: '#b8c2d8',
      dark: '#7a879e',
    },
    warning: {
      main: chipColors.warning,
      light: '#FFD633',
      dark: '#CCa300',
    },
    error: {
      main: chipColors.error,
      light: '#d64449',
      dark: '#9a1216',
    },
    background: {
      default: brandColors.lightGray,
      paper: brandColors.white,
    },
    text: {
      primary: brandColors.indigo,
      secondary: brandColors.mediumGray,
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          borderRadius: 12,
          border: '1px solid rgba(0,0,0,0.06)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorWarning: {
          backgroundColor: chipColors.warning,
          color: '#000000',  // Black text for contrast on yellow
        },
        colorError: {
          backgroundColor: chipColors.error,
          color: '#FFFFFF',  // White text for contrast on dark red
        },
        colorInfo: {
          backgroundColor: chipColors.info,
          color: '#FFFFFF',  // White text for contrast on blue-gray
        },
      },
    },
  },
});
